import {FC, Fragment, useEffect, useState} from 'react';
import {CellItemProps} from '../../../constants/types';
import ViewMode from './ViewMode';
import EditMode from './EditMode';

type EditableFieldProps = {
  cellItem: CellItemProps,
  separator?: string,
  isTimeInput?: boolean,
  validationSchema?: Nullable<object>,
  initialTouched?: {[field: string]: boolean}
}

const EditableField: FC<EditableFieldProps> = ({
  cellItem,
  separator=' ',
  validationSchema=null,
  initialTouched,
  isTimeInput
}) => {
  const [isEditMode, setEditMode] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const {cellData, permission, editModeToggleCallback} = cellItem;

  useEffect(() => {
    if (!!editModeToggleCallback && isEditMode) {
      editModeToggleCallback();
    }
  }, [isEditMode]);

  const labelForViewMode = Object.values(cellData).join(separator);

  return (
    <Fragment>{
      isEditMode ?
        (<EditMode
          isTimeInput={isTimeInput}
          cellItem={cellItem}
          setIsUpdating={setIsUpdating}
          isEditMode={isEditMode}
          setEditMode={setEditMode}
          validationSchema={validationSchema}
          initialTouched={initialTouched}
        />) :
        (<ViewMode
          label={labelForViewMode}
          permission={permission}
          isUpdating={isUpdating}
          setEditMode={setEditMode}
        />)
    }</Fragment>
  );
};

export default EditableField;
